import type { OverviewUserListTaskCheckResponse } from '@/types/apps/overview-user-list-task-check';
import type { ApiResponse, QueryParams } from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export class OverviewUserListTaskCheckService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        base: () => '/api/users/get-overview-user-list-task-check',
    };

    public index(
        params?: QueryParams
    ): Promise<ApiResponse<OverviewUserListTaskCheckResponse>> {
        const url = this.endpoints.base();

        return this.apiClient.fetchApi(url, params);
    }
}
